import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, InputSignal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-claim-details-list',
  imports: [TranslatePipe],
  templateUrl: './claim-details-list.component.html',
  styleUrl: './claim-details-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ClaimDetailsListComponent {
  title: InputSignal<string> = input.required();
  data: InputSignal<any[]> = input.required();
  translationPrefix: InputSignal<string> = input('CASE_DETAIL');

  entries = computed(() => this.data().map((item: { key: any; value: any; }) => ({
    key: this.toSnakeUpperCase(item.key ?? ''),
    value: item.value,
  })))

  constructor() { }

  private toSnakeUpperCase(key: string): string {
    return key.replace(/([a-z])([A-Z])/g, '$1_$2').toUpperCase();
  }



}
